import { INPAGE_SIDEBAR_IFRAME_WINDOW_NAME } from 'ContentEditorUI/lib/app/constants';
import { EVENT_ADD_WINDOW_TO_REACT_DND } from 'ContentEditorUI/lib/inpage/Constants';
export const getSidebarIframeWindow = () => {
  const inpageIframeWindow = window;
  const sidebarIframeWindow =
  // @ts-ignore window object is weird
  inpageIframeWindow.parent.frames[INPAGE_SIDEBAR_IFRAME_WINDOW_NAME].window;
  return sidebarIframeWindow;
};
export function dispatchInitReactDndInSidebar() {
  window.postMessage({
    type: EVENT_ADD_WINDOW_TO_REACT_DND,
    windowName: INPAGE_SIDEBAR_IFRAME_WINDOW_NAME
  }, '*');
}